import { DateTime } from "luxon"
import { displayMessage } from "../../../services/helper"




export default
    [
        {
            field: 'description',
            headerName: displayMessage('DESCRIPTION'),
            headerAlign: 'center',
            // width: 300,
            flex: 1,
            valueGetter: function (params) {
                return `${params.row?.description}`
            }
        },
        {
            field: 'holiday_date',
            headerName: displayMessage('DATE'),
            type: "date",
            // width: 150,
            flex: 1,
            headerAlign: 'center',
            sortable: false,
            align: 'center',
            valueFormatter: (params) => {
                if (!params?.value) {
                    return ''
                }
                const data = DateTime.fromISO(params.value).toUTC(); //.startOf('day').toUTC();
                return data.toFormat('dd/MM/yyyy')
            }
        }
    ]